import * as React from 'react';
import { createContext, useContext, useMemo } from 'react'
import type { ConversationOptions, ConversationProps } from '../types.js'

const defaultOptions: ConversationOptions = {
  scrollToEndAfterMessageSend: false,
  scrollThresholdBeforeShowScrollToBottom: 70,
  preventScrollToBottomOnMount: false,
  disableAutoReadFlow: false,
  hideScrollToBottomFab: false,
}

export const optionsContext = createContext<ConversationOptions>(defaultOptions)

export function ConversationOptionsProvider(props: ConversationProps) {
  const {
    children,
    preventScrollToBottomOnMount = defaultOptions.preventScrollToBottomOnMount,
    scrollThresholdBeforeShowScrollToBottom = defaultOptions.scrollThresholdBeforeShowScrollToBottom,
    scrollToEndAfterMessageSend = defaultOptions.scrollToEndAfterMessageSend,
    disableAutoReadFlow = defaultOptions.disableAutoReadFlow,
    hideScrollToBottomFab = defaultOptions.hideScrollToBottomFab,
  } = props

  const contextValue = useMemo<ConversationOptions>(
    () => ({
      preventScrollToBottomOnMount,
      scrollThresholdBeforeShowScrollToBottom,
      scrollToEndAfterMessageSend,
      disableAutoReadFlow,
      hideScrollToBottomFab,
    }),
    [
      preventScrollToBottomOnMount,
      scrollThresholdBeforeShowScrollToBottom,
      scrollToEndAfterMessageSend,
      disableAutoReadFlow,
      hideScrollToBottomFab,
    ],
  )

  return <optionsContext.Provider value={contextValue}>{children}</optionsContext.Provider>
}

export function useConversationOptions() {
  return useContext(optionsContext)
}
